import React from 'react';
import {
  Component,
  PuzzleTooltip as TpTooltip,
  WithTooltip
} from "puzzle";
import { PROPS, STATE, COMMENTDATA, COMMENTSDTO, QUOTESCOPEDTO } from "./Types"
import * as _ from "lodash"
import { TabStrip, TabStripTab, TabStripSelectEventArguments } from "@progress/kendo-react-layout";

class CommentsDialog extends Component<PROPS, STATE> {
  public state = {
    index: 0,
    arrHeaders: ['quoteLevel', 'action', 'date', 'user', 'comment'],
    data: []
  }

  public tooltip: any;

  componentDidMount() {
    const { vendorId, commentsData } = this.props;
    this.getSelectedTab(vendorId, commentsData);
  };

  /**
   * set data for given vendor
   */
  getSelectedTab = (vendorId: number, commentsData: COMMENTDATA[]): void => {
    if (vendorId) {
      let index = this.getPreselectedTab(commentsData, vendorId);
      this.setState({ data: commentsData[index].commentsDto, index });
    } else {
      this.setState({ data: commentsData[0].commentsDto });
    }
  };
  /**
   * get index from data  for given vendor
   * */
  getPreselectedTab = (data: COMMENTDATA[], vendorId: number): number => {
    return _.findIndex(data, (commentData: COMMENTDATA) => commentData.vendorId === vendorId);
  };

  /**
   *  Handling tab change
   */
  handleSelect = (e: TabStripSelectEventArguments) => {
    const { commentsData } = this.props;
    this.setState({ index: e.selected, data: commentsData[e.selected].commentsDto });
  };

  /**
   * render Qyote level
   */
  renderQuoteLevel = (quoteScopeDto: QUOTESCOPEDTO[]) => {
    const [quoteScopeFirst, ...quoteScopeRest] = quoteScopeDto;
    const { languageName, phaseName, batchName } = quoteScopeFirst;
    const checkForShowMore = quoteScopeDto.length > 1;
    const displayValue = [languageName, batchName, phaseName].filter(Boolean).join(" | ");

    return (
      <div>{displayValue} {checkForShowMore && this.renderQuoteLevelShowMore(quoteScopeRest)}</div>
    )
  }

  /**
   * render show more
   */
  renderQuoteLevelShowMore = (quoteScopeDto: QUOTESCOPEDTO[]): JSX.Element => {
    let toolTipArray: string[] = [];
    const numberOfMore = quoteScopeDto.length;
    quoteScopeDto.forEach(quoteScopeDto => {
      const { languageName, phaseName, batchName } = quoteScopeDto;
      toolTipArray.push([languageName, batchName, phaseName].filter(Boolean).join(", "));
    })
    return (
      <WithTooltip
        context={this}
        htmlTag={'span'}
        title={toolTipArray.filter(Boolean).join('\r')}
      >
        <span title={toolTipArray.filter(Boolean).join('\r')} className={'k-link'}>
          {`${this.translate('formatMore', { numberOfMore })}`}
        </span>
      </WithTooltip>)
  }

  renderBody(): JSX.Element {
    const { commentsData } = this.props;
    const { data, arrHeaders } = this.state;
    return (
      <>
        <TabStrip selected={this.state.index} onSelect={this.handleSelect}>
          {commentsData && commentsData.map((commentData: COMMENTDATA) => {
            return (
              <TabStripTab
                key={commentData.vendorId}
                title={commentData.vendorName}>
                {data.length > 0 &&
                <div className={'tp-grid-comments'} role={'grid'}>
                  <div className={'tp-grid-header'} role={'row'}>
                    {arrHeaders.length > 0 && arrHeaders.map((header: string, index: number) =>
                      <div role={'columnheader'}
                           className={'tp-grid-header-cell tp-text-semibold'}
                           key={index}>{this.translate(header)}</div>
                    )}
                  </div>
                  <div className={'tp-grid-comments-table'} role={'rowgroup'}>
                    {data.map((item: COMMENTSDTO, index: number) => <div className={'tp-grid-row'}
                                                                         role={'row'}
                                                                         key={index}>
                      <div className={'tp-grid-cell tp-text-medium'} role={'gridcell'}>
                        {item.quoteScopeDto.length && this.renderQuoteLevel(item.quoteScopeDto)}
                      </div>
                      <div className={'tp-grid-cell'}
                           role={'gridcell'}>
                        <span className={`tp-grid-cell-actions ${item.quoteStatus.toLowerCase()}`}>
                          {this.translate(`${item.quoteStatus.toLowerCase()}`)}
                        </span>
                      </div>
                      <div className={'tp-grid-cell'}
                           role={'gridcell'}>{this.translateByNamespace('date.dateWithTime', { date: new Date(item.date) })}</div>
                      <div className={'tp-grid-cell tp-text-ellipsis'} role={'gridcell'}>{item.userName}</div>
                      <div className={'tp-grid-cell tp-cell-comment'} role={'gridcell'}>
                        <span dangerouslySetInnerHTML={{ __html: item.comment }}></span>
                      </div>
                    </div>)}
                  </div>
                </div>
                }
              </TabStripTab>
            )
          })}
        </TabStrip>
        <TpTooltip
          ref={(el: any) => this.tooltip = el}
          anchorElement="target"
          openDelay={0}
          position="right"
        />
      </>
    )
  }
}

export default CommentsDialog;
